export enum Routes {
  IntegrationsRouter = '/integrations/*',
  IntegrationsPage = 'market',
  IntegrationsRedirectPage = ':store/redirect',
  ShippingPage = 'shipping',
}
